<div class="access-item" [class.small]="small()">
  @if (!small()) {
    @if (icon()) {
      <div class="icon {{ iconColor() }}">
        <app-svg [src]="icon()"></app-svg>
      </div>
    } @else if (avatarUser()) {
      <div class="icon">
        <app-avatar [user]="avatarUser()"></app-avatar>
      </div>
    } @else if (pendingLetter()) {
      <div class="icon pending">
        {{ pendingLetter() | capitalize }}
      </div>
    } @else {
      <div class="icon">
        <ng-content select="app-access-item-icon"></ng-content>
      </div>
    }
  }
  <div class="info" [class.hide-overflow]="hideOverflow()">
    <div class="header">
      <ng-content select="app-access-item-header"></ng-content>
    </div>
    <div class="body">
      <ng-content select="app-access-item-body"></ng-content>
    </div>
  </div>
  <div class="cta">
    <ng-content select="app-access-item-cta"></ng-content>
  </div>
</div>
